import styled, { keyframes } from 'styled-components'

const fadeit = keyframes`
  0% { opacity: 1; }
  100% { opacity: 0; }
`
export const SpinnerWrapper = styled.div`
	width: 24px;
	height: 24px;
	position: relative;
`

const createBarStyles = (index: number) => {
	const rotate = index * 45
	const delay = (1.2 / 8) * index
	return `
    transform: rotate(${rotate}deg) translate(0, -7.5px);
    animation-delay: ${delay}s;
  `
}

export const Bar = styled.div<{ index: number }>`
	width: 1.6px;
	height: 4.5px;
	background: white;
	border-radius: 1px;
	position: absolute;
	top: 9px;
	left: 10.5px;
	opacity: 0.05;
	animation: ${fadeit} 1.2s linear infinite;
	${({ index }) => createBarStyles(index)}
`
